/**
 *
 */

import styled from 'styled-components'

export const Container = styled.div`
  max-width: 40em;
  padding: 0 1em;

  display: flex;
  flex-direction: column;
  align-items: center;
`
